/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Signals from '../../signals/Signals';

import FormGroup from '../../components/ui/FormGroup/FormGroup';
import FormField from '../../components/ui/FormField/FormField';

import companyUpdate from '../../requests/companyUpdate';
import { extractErrorMessage } from '../../utils/extractErrorMessage';

/**
 *
 */
class OnBoardingCompanyAddress extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.state = {};

		this.onSkip = this.onSkip.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitError = this.onSubmitError.bind(this);

		this.onInputChange = this.onInputChange.bind(this);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const company = this.props.company;
		if (!company) {
			return null;
		}

		const address = company.address;

		const formClasses = classNames({ 'form--submitting': this.state.submitting });

		return (
			<div className={`panel border border--dark ${this.props.className}`}>
				<form
					className={`on-boarding__form ${formClasses}`}
					name="on-boarding"
					onSubmit={this.onSubmit}>
					<div className="on-boarding__header padding border--bottom border--dark">
						<h2>
							<FormattedMessage
								id="onboarding.company.address.title"
								values={{ name: this.props.company.name }}
							/>
						</h2>
					</div>

					<div className="padding-small">
						<FormGroup errors={this.state.errors}>
							<FormField
								className="col--12"
								error={extractErrorMessage(this.state.errors, 'address.address')}>
								<label>
									<FormattedMessage id="onboarding.field.company.address" />
								</label>
								<input
									name="address"
									type="text"
									required
									value={
										this.state.address !== undefined
											? this.state.address
											: address
											? address.address
											: undefined
									}
									onChange={this.onInputChange}
								/>
							</FormField>

							<FormField
								className="col--4"
								error={extractErrorMessage(this.state.errors, 'address.postalCode')}>
								<label>
									<FormattedMessage id="onboarding.field.company.postalcode" />
								</label>
								<input
									name="postalCode"
									type="text"
									placeholder={this.props.intl.formatMessage({ id: 'placeholder.postalcode' })}
									required
									value={
										this.state.postalCode !== undefined
											? this.state.postalCode
											: address
											? address.postalCode
											: undefined
									}
									onChange={this.onInputChange}
								/>
							</FormField>

							<FormField
								className="col--8"
								error={extractErrorMessage(this.state.errors, 'address.city')}>
								<label>
									<FormattedMessage id="onboarding.field.company.city" />
								</label>
								<input
									name="city"
									type="text"
									required
									value={
										this.state.city !== undefined
											? this.state.city
											: address
											? address.city
											: undefined
									}
									onChange={this.onInputChange}
								/>
							</FormField>
						</FormGroup>
					</div>

					<div className="options-footer border--top border--dark grid grid--spread">
						<button
							type="button"
							className="on-boarding__skip-button button--tertiary"
							onClick={this.onSkip}>
							{this.props.intl.formatMessage({ id: 'onboarding.form.skip' })}
						</button>
						<input
							className="on-boarding__submit-button"
							type="submit"
							value={this.props.intl.formatMessage({ id: 'onboarding.form.submit' })}
						/>
					</div>
				</form>
			</div>
		);
	}

	/**
	 *
	 * @param e
	 */
	onInputChange(e) {
		this.state[e.target.name] = e.target.value;
		this.forceUpdate();
	}

	/**
	 *
	 * @param e
	 */
	onSkip(_e) {
		this.props.successCallback(this);
	}

	/**
	 *
	 * @param e
	 */
	onSubmit(e) {
		e.preventDefault();

		const data = {};
		for (const key in this.state) {
			if (this.state.hasOwnProperty(key)) {
				switch (key) {
					case 'city':
						data['address.city'] = this.state[key];
						break;
					case 'address':
						data['address.address'] = this.state[key];
						break;
					case 'postalCode':
						data['address.postalCode'] = this.state[key];
						break;
					case 'errors':
					case 'submitting':
						// do nothing
						break;
					default:
						data[key] = this.state[key];
				}
			}
		}

		this.setState({ errors: null, submitting: true });
		companyUpdate(this.props.company.id, data).then(this.onSubmitSuccess).catch(this.onSubmitError);
	}

	/**
	 *
	 * @param response
	 */
	onSubmitSuccess(response) {
		this.setState({ submitting: false });
		this.props.company.update(response.data);
		this.props.successCallback(this);
	}

	/**
	 *
	 * @param error
	 */
	onSubmitError(error) {
		this.setState({ submitting: false });
		if (error.response && error.response.body) {
			this.setState({ errors: error.response.body });
		} else {
			Signals.Error.dispatch(error);
		}
	}
}

OnBoardingCompanyAddress.propTypes = {
	intl: PropTypes.object,
	company: PropTypes.object.isRequired,
	successCallback: PropTypes.func.isRequired,
	className: PropTypes.string
};

export default injectIntl(OnBoardingCompanyAddress);
